import { isEqual } from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FlatList, StyleSheet, View } from 'react-native';
import runAfterInteractions from '../../utils/runAfterInteractions';
import { Text } from 'trpc-react-native-ui';
import { Icon } from '../../components/common';
import TimelineListViewRow from '../../components/timeline/TimelineListViewRow';
import theme from '../../theme-config';

export default class Events extends Component {
  styles = getStyles();

  shouldComponentUpdate(nextProps) {
    return !isEqual(this.props, nextProps);
  }

  componentDidMount() {
    runAfterInteractions(() => {
      this.props.fetchEvents(false, true);
    });
  }

  refreshEvents = () => this.props.fetchEvents(true);

  getTimeAgoRefreshTimestamp = () => Math.trunc(Date.now() / 15000); // list rerenders at most once each 15 seconds

  renderEvent = ({ item: event }) => (
    <TimelineListViewRow
      ouid={event.ouid}
      parameters={event.parameters}
      amount={event.parameters?.amount}
      credit={event.parameters?.credit}
      detail={event.detail}
      folded={event.folded}
      phoneLine={
        event.parameters?.primaryResourceValue ||
        event.parameters?.sandBox?.characteristics?.primaryResourceValue ||
        event.parameters?.networkEntityId
      }
      timestamp={event.notificationDate}
      type={event.type}
      title={event.title}
      subtitle={event.body}
      timeAgoRefreshTimestamp={this.getTimeAgoRefreshTimestamp()}
    />
  );

  renderSeparator = () => <View style={this.styles.separator} />;

  renderEmptyComponent = () => (
    <View style={this.styles.emptyContainer}>
      <Icon name="empty-inbox" size={100} style={this.styles.inboxIcon} />
      <Text style={this.styles.emptyText}>{this.props.emptyText}</Text>
    </View>
  );

  keyExtractor = event => event.ouid || event.notificationDate + event.type;

  render() {
    const styles = this.styles;
    return (
      <FlatList
        contentContainerStyle={!this.props.events.length && styles.emptyContainer}
        data={this.props.events}
        renderItem={this.renderEvent}
        keyExtractor={this.keyExtractor}
        ListEmptyComponent={this.renderEmptyComponent}
        ItemSeparatorComponent={this.renderSeparator}
        onRefresh={this.refreshEvents}
        refreshing={this.props.isRefreshing}
        extraData={this.getTimeAgoRefreshTimestamp()}
      />
    );
  }
}

const getStyles = () =>
  StyleSheet.create({
    separator: {
      backgroundColor: '#ddd',
      height: 1,
    },
    refreshControl: {
      backgroundColor: '#ddd',
    },
    emptyContainer: {
      flex: 1,
      alignItems: 'center',
      justifyContent: 'center',
    },
    emptyText: {
      textAlign: 'center',
      color: theme.emptyTextColor,
      fontSize: 16,
    },
    inboxIcon: {
      color: theme.emptyInboxColor,
      marginVertical: 30,
    },
  });

Events.propTypes = {
  dataSource: PropTypes.object,
  isRefreshing: PropTypes.bool.isRequired,
  fetchEvents: PropTypes.func,
  skipFirstFetch: PropTypes.bool,
  emptyText: PropTypes.string,
};
